import React from 'react';

import { Box } from '@mui/material';

interface PercentageBarProps {
	interpolatedPercentageForFillWidth: number; // The percentage to display
	realPercentageForDisplay: number;
	fillColor: 'green' | 'red';
	label: string;
}

const PercentageBar: React.FC<PercentageBarProps> = ({
	interpolatedPercentageForFillWidth,
	realPercentageForDisplay,
	fillColor,
	label,
}) => {
	return (
		<Box display="flex" marginBottom="5px">
			<Box marginRight="10px" width="160px" color="gray">
				{label}:
			</Box>
			<Box
				sx={{
					width: '100px',
					backgroundColor: '#eee',
					borderRadius: '5px',
					overflow: 'hidden',
				}}
			>
				<Box
					sx={{
						height: '20px',
						lineHeight: '20px',
						backgroundColor: fillColor,
						textAlign: 'center',
						color: 'white',
						borderRadius: '5px',
						transition: 'width 0.5s ease-in-out',
						width: `${interpolatedPercentageForFillWidth}%`,
					}}
				>
					{realPercentageForDisplay}%
				</Box>
			</Box>
		</Box>
	);
};

export default PercentageBar;
